import gql from 'graphql-tag';

export const RESEND_EMAIL_INVITE = gql`
    mutation resendEmailInvite($input: SignnowEmailInviteInput!) {
        resendEmailInvite(input: $input)
    }
`;
